import { DocumentIcon } from "./DocumentIcon";
import { RenderPdf } from "./ViewUserDocument";
import { UserDocument } from "../../models/UserDocument";

interface Props {
  document?: UserDocument;
  documentSrc?: string;
  style?: any;
}

/**
 * If the document has a thumbnail go get it and display it,
 *  otherwise show a backup icon
 *
 * @param document
 * @constructor
 */
export const DocumentThumbnail = ({
  document,
  documentSrc,
  style,
}: Props): JSX.Element => {

  if (documentSrc && document?.version?.ext?.toLowerCase() === "pdf") {
    return <RenderPdf
      documentSrc={documentSrc + "#toolbar=0&scrollbar=0"}
      style={{
        pointerEvents: "none",
        overflow: "hidden",
        ...style,
      }}
    />
  } else if (document?.version?.cloudUrl) {
    return <DocumentIcon
      title={document?.version?.title}
      extension={"url"}
    />
  } else if (documentSrc && canDisplayThumbnail(document?.version?.ext)) {
    return <img
      src={documentSrc}
      alt={document?.version?.title}
      title={document?.version?.title}
      style={{
        borderRadius: "10px",
        border: "1px inset",
        maxWidth: "100%",
        maxHeight: "100%",
        ...style,
      }}
    />
  }

  return <DocumentIcon
    title={document?.version?.title}
    extension={document?.version?.ext}
  />
}

function canDisplayThumbnail(ext?: string): boolean {
  if (!ext) {
    return false
  }

  return [
    "png",
    "webp",
    "jpg",
    "jpeg",
    "bmp",
    "gif",
  ].indexOf(ext) !== -1
}
